import { createFileRoute } from '@tanstack/react-router';
import { requireFeature } from '@portal/platform/guards';
import { BuilderPage } from '@/features/template-builder/builder-page';
import { parseBuilderSearch, type BuilderSearch } from '@/features/template-builder/search';

/** The PDF template builder; see the email builder's route. */
export const Route = createFileRoute('/_app/pdf-templates/builder')({
  staticData: { featureKey: 'template-builder-pdf' },
  validateSearch: (search: Record<string, unknown>): BuilderSearch =>
    parseBuilderSearch(search, 'pdf'),
  beforeLoad: ({ context, location }) =>
    requireFeature(context, location, {
      feature: 'template-builder-pdf',
      permissions: ['template-tyres:read'],
    }),
  component: Builder,
});

function Builder() {
  const { group, type } = Route.useSearch();
  // Keyed, so a link to another group or type starts from it rather than the open one.
  return (
    <BuilderPage
      key={`${group ?? ''}:${type ?? ''}`}
      kind="pdf"
      initialGroup={group}
      initialType={type}
    />
  );
}
